module.exports = __webpack_public_path__ + "media/v2/components/HomePage/shared/PrizeSlider/img/secondary-2ad1193e2f64423948a0163ebefd0229.svg";